import React, { createRef } from 'react';
import { Text, View, StyleSheet, Keyboard, InteractionManager } from 'react-native';

import {
  I18n,
  Navigation,
  NavBar,
  Container,
  ProfileAvatar,
  NoCasesView,
  OPComponent,
  Utils,
} from '../components';
import { COLOR, FONT, FONT_SIZE, THEME, __WEB__, __IOS__ } from '../../constants/styles';
import { PENDING, REQUESTING, SUCCESS, FAILED } from '../../actions/statusTypes';

import {
  registerNotificationReceivedHandler,
  unRegisterNotificationReceivedHandler,
} from '../../notificationsHandlers';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { getAssociatedEmployer } from '../../selectors/employers';
import { getCurrentEmployer } from '../../selectors/entities';
import { EMPLOYER_TYPE_AIRFORCE } from '../../constants/employerTypes';
import {
  createGroupMessage,
  setCurrentMessage,
  fetchTopicsAndMessage,
  removeGroupMessage,
  uploadImageAndCreateGroupMessage,
  handlePushReceived,
  createTopic,
  setNavMode,
} from './actions';
import {
  getMessagesOfCurrentConversation,
  getMembersOfCurrentConversation,
  getGiftTypes,
  getCurrentTopic,
} from './selector';
import { changeCurrentCase } from '../cases/actions';

import { isSameUser, isSameTime, isSameType } from './chat/utils';

import ConversationHeader from './conversation_header';
import { GiftedChat as Chat } from './chat/GiftedChat';
import Accessories from './accessories';
import GiftTool from './gift_tool';
import TagMembers from './tag_members';
import GiftDisplay from './gift_display';
import MessagingSubNav from './sub_nav';
import navModes from './nav_modes';
import TopBarSetup from '../../navbar_maintab_setup';

import { MESSAGING_TAB } from '../../constants/tabs';

const INITIAL_NUM_MESSAGES_TO_RENDER = __WEB__ ? 20 : 11;
const COMPOSER_HEIGHT = __WEB__ ? 114 : 104;
const BOTTOM_OFFSET = __WEB__ ? 0 : 80;
const GIFT_HEIGHT = 190;
const GIFT_COMPOSER_HEIGHT = COMPOSER_HEIGHT + GIFT_HEIGHT;
const AT_REGEX = /{{@.+?}}/gi;
const DELETE_CONFIRM_PROPS = {
  title: 'Delete Message',
  description: 'Are you sure you want to delete your message?',
  confirm: 'Yes, Delete Message',
};

const chatRef = createRef();
const giftDisplayRef = createRef();

let imageMessagePlaceholderUniqueId = 2;

class Messages extends OPComponent {
  static navigatorStyle = NavBar && NavBar.navigatorStyleRootScreen;

  _atDisplayTableFromMembers(members) {
    return members.reduce((result, profile) => {
      const userId = profile.userId;
      const label = `${profile.rank ? profile.rank + ' ' : ''}${profile.fullName}`;
      result[`{{@${userId}}}`] = label;
      return result;
    }, {});
  }

  _getIndexOfCurrentMessage(messageId, messages) {
    if (!messageId) return null;
    const i = messages.findIndex((m) => m.messageId === messageId);
    if (i < 0) return null;
    return i;
  }

  constructor(props) {
    super(props);

    this._ats = {};
    this._atDisplayTable = this._atDisplayTableFromMembers(props.members);
    this._atRegex = /{{@.+?}}/gi;
    this._skipOneScrollTrigger = false;
    this._handlingScroll = false;
    this._focusTextInputOnUpdate;
    this._playLatestGift = false;

    const focusToMessageId = props.currentMessageId;
    const focusMessageIndex = this._getIndexOfCurrentMessage(focusToMessageId, props.messages);
    // const focusToMessageId = 46;

    this.state = {
      showGifts: false,
      composerHeight: COMPOSER_HEIGHT,
      keyboardHeight: 0,
      confirmationOpts: null,
      text: '',
      inputSelection: null,
      scrollTriggerToggle: false,
      screenVisible: false,
      focusMessageIndex,
      imageMessagePlaceholders: [],
    };
  }

  navigationButtonPressed = ({ buttonId }) => {
    const { componentId } = this.props;

    if (NavBar.handleButtonPress(componentId, buttonId)) return;
  };
  handleDeepLink = async ({ link, payload }) => {
    const props = this.props;
    if (link === MESSAGING_TAB || link === 'messaging/main') {
      Navigation.switchToTab(MESSAGING_TAB, this.props.componentId);

      const startConvoWith = payload?.startConvoWith;
      const caseId = payload?.caseId;
      if (startConvoWith && caseId) {
        this.deepLinkToCaseTopic(startConvoWith, caseId);
      }
    }
  };

  deepLinkToCaseTopic = async (startConvoWith, caseId) => {
    const props = this.props;
    if (props.status === REQUESTING) return;
    await props.actions.changeCurrentCase(caseId);
    await props.actions.setNavMode(navModes.CASE);
    const members = [{ userId: startConvoWith }, { userId: this.props.userProfile.userId }];
    this.props.actions.createTopic({
      name: '_',
      description: '',
      members,
    });
  };

  handlePushReceived = (notification) => {
    this.props.actions.handlePushReceived(notification);
  };
  componentDidMount() {
    Utils.trackScreen('Messaging', 'Messages');

    Navigation.registerForButtonEvents(this, null, 'Messages');
    registerNotificationReceivedHandler(this.handlePushReceived);
  }
  componentWillUnmount() {
    Navigation.unRegisterForButtonEvents(this);
    unRegisterNotificationReceivedHandler(this.handlePushReceived);
  }
  componentDidAppear(id) {
    console.info('>>> messaging componentDidAppear');
    const props = this.props;
    this.setState({ screenVisible: true });
    Navigation.trackActiveTabNum(MESSAGING_TAB);
    if (this._playLatestGift && props.messages.length) {
      const mInd = props.messages.length - 1;
      const latestMessage = props.messages[mInd];
      if (latestMessage.gift) {
        this.playGiftMessage(latestMessage, false);
      }
    }
    this._playLatestGift = false;
  }
  componentDidDisappear(id) {
    console.info('>>> messaging componentDidDisappear');
    this.setState({ screenVisible: false });
  }

  componentDidUpdate(prevProps, prevState) {
    const props = this.props;
    if (this.state.screenVisible && !prevState.screenVisible) {
      if (props.fetchAllStatus !== SUCCESS && props.fetchAllStatus !== REQUESTING) {
        props.actions.fetchTopicsAndMessage();
      }
    }

    if (props.members !== prevProps.members) {
      this._atDisplayTable = this._atDisplayTableFromMembers(props.members);
    }

    if (props.currentTopic?.topicId !== prevProps.currentTopic?.topicId) {
      const focusToMessageId = props.currentMessageId;
      this.setState({
        imageMessagePlaceholders: [],
        focusMessageIndex: this._getIndexOfCurrentMessage(focusToMessageId, props.messages),
      });
    }

    if (props.messages !== prevProps.messages) {
      if (props.messages.length) {
        const mInd = props.messages.length - 1;
        const latestMessage = props.messages[mInd];
        let latestImageMessageFilename = latestMessage.image || latestMessage.video;
        let imageMessagePlaceholders = this.state.imageMessagePlaceholders;
        if (latestImageMessageFilename) {
          imageMessagePlaceholders = imageMessagePlaceholders.filter((item) => {
            return item.image !== latestImageMessageFilename;
          });
        }
        this.setState({ imageMessagePlaceholders });

        if (latestMessage.gift) {
          if (this.state.screenVisible) {
            this.playGiftMessage(latestMessage, false);
          } else {
            this._playLatestGift = true;
          }
        }
      }
      if (this.state.focusMessageIndex === null && !__WEB__) {
        // timeout to wait for a render cycle
        setTimeout(() => {
          this._skipOneScrollTrigger = true;
          chatRef.current?.scrollToBottom(false);
        }, 1);
      }
    }

    if (this.state.text !== prevState.text) {
      if (this._focusTextInputOnUpdate) chatRef.current?.focusTextInput();
    }

    if (this._scrollToOnUpdateProps) {
      const { prevScrollToIndex, scrollTo } = this._scrollToOnUpdateProps;
      this._scrollToOnUpdateProps = null;
      this.scrollToCurrentMessage(prevScrollToIndex, scrollTo);
    }
  }

  getVisibleMessages() {
    const props = this.props;
    const messages = props.messages.concat(this.state.imageMessagePlaceholders);
    const i = this.state.focusMessageIndex;
    let scrollToIndex = null;
    let messagesSliced;
    if (i === null) {
      messagesSliced = messages.slice(0);
    } else {
      const indexOfMessage = Math.min(i, messages.length - 1);
      const listEndOffset = INITIAL_NUM_MESSAGES_TO_RENDER - 1;
      const endI = Math.min(messages.length, i + listEndOffset);
      messagesSliced = messages.slice(0, endI);
      scrollToIndex = messagesSliced.length - 1 - indexOfMessage;
    }
    this._scrollToOnUpdateProps = {
      prevScrollToIndex: this._scrollToOnUpdateProps?.scrollTo || null,
      scrollTo: scrollToIndex,
    };
    return messagesSliced.reverse();
  }

  loadMoreRecent() {
    if (this.state.focusMessageIndex !== null) {
      let focusMessageIndex = this.state.focusMessageIndex + INITIAL_NUM_MESSAGES_TO_RENDER;
      if (
        focusMessageIndex >=
        this.props.messages.length + this.state.imageMessagePlaceholders.length - 1
      ) {
        focusMessageIndex = null;
      }
      this.setState({ focusMessageIndex });
    }
    this.props.actions.setCurrentMessage(null);
  }

  scrollToCurrentMessage = (prevScrollToIndex, scrollTo) => {
    if (scrollTo === null) return;

    if (prevScrollToIndex === null) {
      setTimeout(() => {
        InteractionManager.runAfterInteractions(() => {
          chatRef.current?.scrollToIndex({
            index: scrollTo,
            animated: false,
          });
        });
      }, 10);
    }
  };

  renderAtLink = (text) => {
    return `@${this._atDisplayTable[text]}`;
  };
  handleAtsTableChanged = (ats) => {
    this._ats = ats || {};
  };
  formatMessageBeforeSend = (text) => {
    return Object.keys(this._ats).reduce((fixedUpText, atString) => {
      return fixedUpText.replaceAll(`@${atString}`, `{{@${this._ats[atString]}}}`);
    }, text);
  };
  addPlaceholderMessageImageSend = (message, previewUri) => {
    const props = this.props;
    const placeholderMessage = {
      ...message,
      _id: -imageMessagePlaceholderUniqueId,
      createdAt: new Date(),
      user: {
        _id: props.userProfile.userId,
        name: props.userProfile.fullName,
      },
      imagePlaceholder: true,
      previewUri,
    };
    imageMessagePlaceholderUniqueId++;
    const imageMessagePlaceholders = this.state.imageMessagePlaceholders;
    imageMessagePlaceholders.push(placeholderMessage);
    this.setState({ imageMessagePlaceholders });
    return placeholderMessage;
  };
  sendGift = (text) => {
    this.toggleGifts();
    this.sendMessages([{ text }]);
  };
  sendImageMessages = (imageMessage) => {
    if (!imageMessage) return;
    let message = {
      text: imageMessage.comment,
    };
    const placeholderMessage = this.addPlaceholderMessageImageSend(
      message,
      imageMessage?.thumbnailUri || imageMessage?.image?.uri
    );
    this.props.actions
      .uploadImageAndCreateGroupMessage(imageMessage.image, message)
      .then(function (result) {
        placeholderMessage.image = result;
      });
  };
  sendMessages = (messages = []) => {
    messages.forEach((message) => {
      this.props.actions.createGroupMessage({
        text: this.formatMessageBeforeSend(message.text),
      });
    });
  };
  deleteMessage = (message) => {
    this.props.actions.removeGroupMessage(message.messageId);
  };
  closeConfirmation = () => {
    this.setState({ confirmationOpts: null });
  };
  handleDeletePress = (message) => {
    this.setState({
      confirmationOpts: {
        ...DELETE_CONFIRM_PROPS,
        onConfirmed: function () {
          this.deleteMessage(message);
          this.closeConfirmation();
        },
        onCancelled: this.closeConfirmation,
      },
    });
  };
  toggleGifts = () => {
    Keyboard.dismiss();
    this.setState({
      showGifts: !this.state.showGifts,
      composerHeight: this.state.showGifts ? COMPOSER_HEIGHT : GIFT_COMPOSER_HEIGHT,
    });
  };

  handleInputTextChange = (text) => {
    this.setState({ text });
  };
  handleSelectionChange = (e) => {
    this.setState({ inputSelection: e.nativeEvent.selection });
  };
  handleKeyboardHeight = (keyboardHeight) => {
    this.setState({ keyboardHeight });
  };
  handleMemberTagged = (text) => {
    this._focusTextInputOnUpdate = true;
    this.setState({ text });
  };

  renderAvatar = (data) => {
    const userId = this.props.userProfile?.userId;
    if (data.currentMessage.type == 'flavor') return null;
    // if (data.currentMessage.user._id === userId) return <View style={{ width: 50 }} />;

    if (
      isSameUser(data.currentMessage, data.nextMessage) &&
      isSameTime(data.currentMessage, data.nextMessage)
    )
      return <View style={{ width: 60 }} />;

    return (
      <View style={{ width: 60 }}>
        <ProfileAvatar
          profile={data.currentMessage.user.profile}
          circleStyles={styles.profileViewStyle}
        />
      </View>
    );
  };
  playGiftMessage(message, force = false) {
    giftDisplayRef.current?.playMessage(message, force);
  }

  handleScroll = ({ nativeEvent }) => {
    if (this._handlingScroll) return;

    if (this.state.focusMessageIndex === null) {
      if (nativeEvent.contentOffset.y <= 50) {
        !this._skipOneScrollTrigger &&
          this.setState({ scrollTriggerToggle: !this.state.scrollTriggerToggle });
        this._skipOneScrollTrigger = false;
      }
      return;
    }
    if (nativeEvent.contentOffset.y <= 50) {
      this._handlingScroll = true;
      this.loadMoreRecent();
    }
    setTimeout(() => {
      this._handlingScroll = false;
    }, 1000);
  };

  renderAccessory = () => {
    return (
      <Accessories
        onGiftPress={this.toggleGifts}
        showingGifts={this.state.showGifts}
        onImageMessageAdd={this.sendImageMessages}
      />
    );
  };

  renderContent() {
    if (!this.state.screenVisible) return null;

    const props = this.props;
    const visibleMessages = this.getVisibleMessages();

    const chatUser = { _id: props.userProfile?.userId };

    if (!props.coldStartFinished) {
      return <View style={styles.container} />;
    } else if (!props.isAirforce && !props.caseCount) {
      return <NoCasesView />;
    }

    return (
      <Container
        style={THEME.container}
        confirmationOpts={this.state.confirmationOpts}
        renderActivityOverlay={props.fetchAllStatus === REQUESTING}
      >
        {!__WEB__ && !!props.isStaffOnEmployer && (
          <View style={styles.navContainer}>
            <MessagingSubNav />
          </View>
        )}
        <ConversationHeader
          triggerScroll={this.state.scrollTriggerToggle}
          screenVisible={this.state.screenVisible}
          isAirforce={props.isAirforce}
          messageCount={visibleMessages?.length}
        />

        <View style={THEME.transparentContainer}>
          <Chat
            ref={chatRef}
            editable={!!(props.canEdit && props.currentTopic)}
            disabled={!props.currentTopic}
            messages={visibleMessages}
            bottomOffset={BOTTOM_OFFSET + (this.state.showGifts ? GIFT_HEIGHT : 0)}
            composeToolbarHeight={COMPOSER_HEIGHT}
            showAvatarForEveryMessage={false}
            renderUsernameOnMessage={true}
            renderAvatar={this.renderAvatar}
            renderNameAccessoryView={null}
            renderNameAccessoryView2={null}
            renderAccessory={this.renderAccessory}
            onSend={this.sendMessages}
            initialNumToRender={INITIAL_NUM_MESSAGES_TO_RENDER}
            onScrollToIndexFailed={null}
            scrollToBottom={true}
            handleOnScrollToBottom={null}
            handleOnScroll={this.handleScroll}
            user={chatUser}
            directChatMode={false}
            onDeletePress={this.handleDeletePress}
            alwaysShowSend={true}
            placeholder={I18n.t('messaging.placeholder')}
            onInputTextChanged={this.handleInputTextChange}
            onSelectionChange={this.handleSelectionChange}
            onKeyboardHeight={this.handleKeyboardHeight}
            text={this.state.text}
            textAtRegexp={AT_REGEX}
            renderAtLink={this.renderAtLink}
            playGiftMessage={this.playGiftMessage}
          />
        </View>

        {!!props.canEdit && !!this.state.showGifts && (
          <GiftTool
            gifts={props.giftMessages}
            onSelect={this.sendGift}
            onClose={this.toggleGifts}
          />
        )}

        <TagMembers
          bottomOffset={BOTTOM_OFFSET + (this.state.showGifts ? GIFT_HEIGHT : 0)}
          keyboardHeight={this.state.keyboardHeight}
          composerHeight={this.state.composerHeight}
          members={props.members}
          inputSelection={this.state.inputSelection}
          text={this.state.text}
          onText={this.handleMemberTagged}
          onAts={this.handleAtsTableChanged}
        />

        <GiftDisplay ref={giftDisplayRef} giftMessages={props.giftMessages} />
      </Container>
    );
  }
  render() {
    return (
      <View style={{ flex: 1 }}>
        <TopBarSetup componentId={this.props.componentId} />
        {this.renderContent()}
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {},
  navContainer: {
    height: 50,
  },
  profileViewStyle: {
    width: 50,
    height: 50,
  },
});

function mapStateToProps(state, ownProps) {
  const associatedEmployer = getAssociatedEmployer(state);
  const messages = getMessagesOfCurrentConversation(state);
  // console.info('>>>> topic', getCurrentTopic(state))
  const currentMessageId = state.screens.messaging.currentMessageId;
  return {
    status: state.screens.messaging.status,
    fetchAllStatus: state.screens.messaging.fetchAllStatus,
    navMode: state.screens.messaging.navMode,
    isAirforce: associatedEmployer?.uiConfig?.type === EMPLOYER_TYPE_AIRFORCE,
    canEdit: true,
    messages,
    userProfile: state.entities.userProfile,
    currentMessageId,
    // currentMessageId: 4130,
    members: getMembersOfCurrentConversation(state),
    giftMessages: getGiftTypes(state),
    currentTopic: getCurrentTopic(state),
    coldStartFinished: state.application.coldStartFinished,
    caseCount: Object.keys(state.entities?.cases || {}).length || 0,
    associatedEmployer,
    isStaffOnEmployer: !!getCurrentEmployer(state),
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        createGroupMessage,
        setCurrentMessage,
        fetchTopicsAndMessage,
        removeGroupMessage,
        uploadImageAndCreateGroupMessage,
        handlePushReceived,
        createTopic,
        changeCurrentCase,
        setNavMode,
      },
      dispatch
    ),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(Messages);
